"use client";

import { ChartProductUsageLegendProps, ProductUsageItem } from "../types";
import { useTranslation } from "react-i18next";

export function ChartProductUsageLegend({
  products,
  viewMode,
  getColor,
  getName,
  formatCurrency,
}: ChartProductUsageLegendProps) {
  const getDisplayValue = (p: ProductUsageItem) =>
    viewMode === "currency"
      ? formatCurrency(p.monetary_value)
      : p.credits_value;
  const [translate] = useTranslation(["dashboard"]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-6 border-t border-secondary-500 pt-6 px-6">
      {products.map((product, index) => (
        <div key={`${product.type}-${index}`} className="space-y-1">
          <div className="flex items-center gap-2">
            <div
              className={`w-3 h-3 rounded-full bg-${getColor(product.type)}`}
            />
            <span className="text-sm font-medium text-darkgray-600">
              {translate(getName(product.type))}
            </span>
          </div>
          <div className="text-base font-normal text-neutral-900">
            {getDisplayValue(product)}
          </div>
        </div>
      ))}
    </div>
  );
}
